import { useSelector } from 'react-redux';
import '../../css/app.css'
import '../../css/common.css'
import '../../css/main.css'
import Page from '../../Page';
import React from 'react';
import { useState, useEffect, useRef } from 'react';

function LoadingModal() {
    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);
    return (
        <div className="pay_loading_wrap" >
            <div className="pay_loading">
                {
                    hostLogoImg == "onu"
                        ?
                        <img src="/img/onu.png" alt="loading" style={{ width: "200px" }} />
                        :
                        <img src="/img/dl_logo_white.png" alt="loading" style={{ width: "200px" }} />
                }
            </div>
        </div>
    )
}

function MessageModal({ message }) {
    const [messageModal, setMessageModal] = useState(false)

    useEffect(() => {
        if (message.msg) {
            setMessageModal(true)
        }
    }, [message]);


    const handleEsc = (event) => {
        if (event.key === 'Escape') {
            setMessageModal(false);
        }
    };

    document.addEventListener('keydown', handleEsc);

    return (
        <>
            {
                messageModal
                    ?
                    <div id="alert_modal" className="modal alert_modal" tabindex="-1" >
                        <div className="modal-dialog" style={{ minWidth: "300px", maxWidth: "400px", width: "95%" }}>
                            <h2 className="text-center font-bold text-lg pt-5">{message?.msg ?? ""}</h2>
                            <div className="modal-footer">
                                <button type="button" id="alert_ok_btn" className="btn w-20 btn_ok" onClick={() => setMessageModal(false)}>확인</button>
                            </div>
                        </div>
                    </div>
                    :
                    ""
            }
        </>
    )
}

export { LoadingModal, MessageModal }